module.exports = __webpack_public_path__ + "img/xiaoxiong.dbcba506.png";